module.exports = __webpack_public_path__ + "static/media/classic_beauty_3.915c436d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/classic_beauty_3.jpg
// module id = 512
// module chunks = 0